/**
 * WordPress dependencies
 */
import { store, getContext } from "@wordpress/interactivity";
import {
  getGeoLocation,
  filterAndSort,
  doSearch,
  getStoreImageData,
  loadThumbnails,
} from "../js/utils";

const smallDisplayThereshold = 782;

const { state } = store("cc-lvlgroup-marketing-store-list", {
  state: {
    isWaiting: false,
    isLoaded: false,
    isSmallDisplayInternal: false,
    get isObjectContain() {
      const context = getContext();

      return () => {
        if (context.shop.thumbnail.alt === "SKECHERS by LVL Group") {
          return "contain";
        }
        return "cover";
      };
    },
    get isSelected() {
      const context = getContext();
      return function () {
        return state.shopSelectedId === context.shop.storeId;
      };
    },
    isFilterSelected() {
      const context = getContext();
      return function () {
        return context.locationFilterSelected === "0";
      };
    },
    get isSmallDisplay() {
      return () => {
        state.isSmallDisplayInternal =
          window.outerWidth < smallDisplayThereshold;
        return state.isSmallDisplayInternal;
      };
    },
    get isNotSmallDisplay() {
      return () => !this.isSmallDisplay();
    },
  },
  actions: {
    onClickStore(event) {
      if (!state.isSmallDisplay()) {
        const context = getContext();
        state.shopSelectedId = context.shop.storeId;
        state.shopSelected = context.shop;
      }
    },
    onCountryFilterChanged(event) {
      const context = getContext();
      context.countryFilter = event.target.value;
    },
    onAddressFilterChanged(event) {
      const context = getContext();
      context.addressFilter = event.target.value;
    },
    onClickSearch() {
      const context = getContext();
      state.shopView = filterAndSort(context, state);

      if (state.shopView.length === 0) {
        alert("No stores found");
        state.shopView = state.shops;
        state.shopSelectedId = state.shops[0].storeId;
        state.shopSelected = state.shops[0];
        return;
      }
      state.shopSelectedId = state.shopView[0].storeId;
      state.shopSelected = state.shopView[0];
    },
    onClickReset() {
      const context = getContext();
      context.countryFilter = "0";
      context.addressFilter = "";
      state.shopView = filterAndSort(context, state);
    },
    onKeyPress(event) {
      if (event.key === "Enter") {
        event.preventDefault();
        const el = document.getElementById("buttonSearch");
        el.focus();
        el.click();
      }
    },
  },
  callbacks: {

    onInit() {
      if (state.isSmallDisplay() && !state.thumbnailsLoaded) {
        loadThumbnails(state);
      }
      if (state.userGeoLocation.geoType !== "browser") {
        state.isWaiting = true;
        getGeoLocation()
          .then((position) => {
            state.userGeoLocation = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
              geoType: "browser",
            };
            state.shopView = filterAndSort(context, state);

            state.shopSelectedId = state.shops[0].storeId;
            state.shopSelected = state.shops[0];

            state.isWaiting = false;
            return;
          })
          .catch((error) => {
            console.log(error);
            state.isWaiting = false;
            return;
          });
      }

      state.shopSelectedId = state.shops[0].storeId;
      state.shopSelected = state.shops[0];
    },
    onWindowResize() {
      if (state.isSmallDisplay() && !state.thumbnailsLoaded) {
        loadThumbnails(state);
      }
    },
    getLazyImageAttributes: function* () {
      if (state.isSmallDisplay() && !state.thumbnailsLoaded) {
        loadThumbnails(state);
      }
    },
  },
});

export { state };
